// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__IQa37","imageUploader":"EGiftCard_imageUploader__2oHGb"};